import * as React from "react";
import Link from "next/link";
import { Icon } from "@nju/icons";
import { portalRoutes } from "@nju/routes";
import { A, Button, Panel, Separator, Text } from "@nju/ui";

export function ChangeConsentsError({
  onRetry,
  isSubmitting,
}: {
  onRetry: () => void;
  isSubmitting: boolean;
}) {
  return (
    <Panel>
      <div className="flex items-center flex-col">
        <Text
          align="center"
          size={{
            "@onlyMobile": "l",
            "@fromTablet": "keyM",
          }}
          weight="bold"
        >
          chwilowy problem techniczny
        </Text>
        <Separator size="s" tone="invisible" />
        <Icon
          className="w-[90px] h-[90px] only-mobile:w-[60px] only-mobile:h-[60px] "
          name="hand-incircle-fail"
        />
        <Separator size="s" tone="invisible" />
        <Text
          align="center"
          size={{
            "@onlyMobile": "m",
            "@fromTablet": "l",
          }}
        >
          Wystąpił problem techniczny i nie mogliśmy teraz zapisać zmian.
        </Text>
        <Separator size="xs" tone="invisible" />
        <Text
          align="center"
          size={{
            "@onlyMobile": "m",
            "@fromTablet": "l",
          }}
        >
          Spróbuj ponownie za kilka minut.
        </Text>
        <Separator size="xl" />
      </div>
      <div className="flex gap-3 flex-col from-tablet:flex-row justify-center">
        <Link
          href={portalRoutes.mojeKonto.mojProfil.index.get()}
          passHref={true}
        >
          <A
            size={{
              "@onlyMobile": "s",
            }}
            variant="secondary"
          >
            wróć do konta
          </A>
        </Link>
        <Button
          display="inline"
          isLoading={isSubmitting}
          onPress={onRetry}
          size={{ "@onlyMobile": "s" }}
        >
          spróbuj ponownie
        </Button>
      </div>
    </Panel>
  );
}
